import { HttpContextToken, HttpErrorResponse, type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, throwError } from 'rxjs';

export const REQUEST_ID_HEADER_NAME = 'X-Request-Id';
/** Optional read-only enrichment handles failures locally, without a global snackbar. */
export const LOCAL_ERROR_FEEDBACK = new HttpContextToken<boolean>(() => false);

const unexpectedErrorMessage = 'Ocurrió un error inesperado.';
const networkErrorMessage = 'No fue posible conectar con el servicio. Intenta nuevamente.';
const requestIdPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const unexpectedErrorInterceptor: HttpInterceptorFn = (request, next) => {
  const snackBar = inject(MatSnackBar);

  return next(request).pipe(
    catchError((error: unknown) => {
      const message = getUnexpectedErrorMessage(error);
      if (message !== null && !request.context.get(LOCAL_ERROR_FEEDBACK)) {
        snackBar.open(message, 'Cerrar', { duration: 8000 });
      }

      return throwError(() => error);
    }),
  );
};

export function getUnexpectedErrorMessage(error: unknown): string | null {
  if (!(error instanceof HttpErrorResponse)) {
    return null;
  }

  if (error.status === 0) {
    return networkErrorMessage;
  }

  if (error.status < 500 || isKnownFunctionalError(error)) {
    return null;
  }

  const requestId = error.headers.get(REQUEST_ID_HEADER_NAME)?.trim();
  return requestId !== undefined && requestIdPattern.test(requestId)
    ? `${unexpectedErrorMessage} Referencia: ${requestId}`
    : unexpectedErrorMessage;
}

function isKnownFunctionalError(error: HttpErrorResponse): boolean {
  if (error.status === 500) {
    return false;
  }

  const body = error.error;
  return (
    typeof body === 'object' &&
    body !== null &&
    'code' in body &&
    typeof body.code === 'string' &&
    body.code !== 'UnexpectedError'
  );
}
